import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function MidCTA() {
  const scrollToCheckout = () => {
    const target = document.getElementById('pricing');
    if (!target) return;
    const start = window.scrollY;
    const end = target.getBoundingClientRect().top + window.scrollY;
    const distance = end - start;
    const duration = 1800;
    let startTime: number | null = null;
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + distance * easeInOutCubic(progress));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  return <section className="w-full bg-[#0a0f1a] py-8 md:py-12 px-4 border-y border-[#c9a84c]/10" data-id="element-110">
      <div className="max-w-3xl mx-auto text-center" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-112">
          {/* Price Comparison */}
          <div className="mb-3 md:mb-4 flex items-center justify-center gap-2 md:gap-3" data-id="element-113">
            <span className="text-[#ef4444] line-through text-base md:text-lg font-bold opacity-70" data-id="element-114">
              $47
            </span>
            <span className="text-[#c9a84c] text-2xl md:text-3xl font-bold" data-id="element-115">
              $6.36
            </span>
            <span className="bg-[#10b981]/10 border border-[#10b981]/30 rounded-full px-2 md:px-3 py-0.5 text-[#10b981] font-bold text-[10px] md:text-xs uppercase tracking-wider" data-id="element-116">
              Save 86%
            </span>
          </div>

          <button onClick={scrollToCheckout} className="group relative w-full md:w-auto px-6 md:px-8 py-3.5 md:py-4 bg-[#c9a84c] text-[#0f1724] text-lg md:text-xl font-bold rounded-lg shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] hover:scale-[1.02] transition-all duration-300" data-id="element-117">
            GET THE SHADOW BLUEPRINT — $6.36
          </button>

          <div className="mt-4 space-y-2" data-id="element-118">
            <p className="text-[#f5f0e8]/60 text-sm" data-id="element-119">
              Join 2,400+ investors who downloaded this month
            </p>
            <div className="flex items-center justify-center gap-2 text-[#f5f0e8]/40 text-xs uppercase tracking-wider" data-id="element-120">
              <Lock className="w-3 h-3" data-id="element-121" />
              <span data-id="element-122">Instant Digital Delivery</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}